import * as zip from '@zip.js/zip.js';
import { saveAs } from 'file-saver';
import { DownloadingState, useStore } from '~src/store';

export async function saveFilesToZip(
  fileData: { location: string; name: string; path?: string }[],
  zipName?: string
) {
  // console.log(`saveFilesToZip: fileData`, fileData);
  try {
    const zipFilename = zipName
      ? `${zipName}.zip`
      : `Download__${Date.now()}.zip`;

    // Create a BlobWriter to store the ZIP file
    const blobWriter = new zip.BlobWriter('application/zip');
    const zipWriter = new zip.ZipWriter(blobWriter, { level: 5 });

    useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);

    const fetchData = fileData.map(({ path, name, location }) => {
      const filename = path ? `${path}/${name}` : name;
      return zipWriter.add(
        filename,
        new zip.HttpReader(location, {
          preventHeadRequest: true,
          useXHR: true,
        }),
        {
          onprogress: async (progress: number, total: number) => {
            if (total) {
              const fileProgress = ((progress / total) * 100).toFixed(2);
              // console.log(`TotalSize: fileProgress `, fileProgress);
              useStore.getState().totalDownloadSize(Number(fileProgress));
              useStore.getState().changeTotalFileSize(total);
            }
          },
        }
      );
    });

    await Promise.all(fetchData);

    // Close the ZIP and get the final Blob
    const blob = await zipWriter.close();
    saveAs(blob, zipFilename);

    useStore.getState().changeDownloadingState(DownloadingState.FINISHING);

    setTimeout(() => {
      useStore.getState().changeDownloadingActive(false);
    }, 3_000);
  } catch (e) {
    console.log(e);
  }
}

/*
export async function saveFilesToZip(
  fileData: { location: string; name: string; path?: string }[]
) {
  console.log(`saveFilesToZip: fileData`, fileData);

  useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);

  for (const filesData of fileData) {
    try {
      const zipFilename = `Download__${Date.now()}.zip`;
      const worker = new Worker(new URL('./zipWorker.js', import.meta.url), {
        type: 'module',
      });

      worker.postMessage(filesData);

      worker.addEventListener('message', async (event) => {
        const { zipBlob } = event.data;
        saveAs(zipBlob, zipFilename);
      });

      worker.addEventListener('error', (error) => {
        console.error('ZIP Worker Error:', error);
      });
    } catch (error) {
      console.error('ZIP download failed:', error);
    }
  }

  useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
  setTimeout(() => {
    useStore.getState().changeDownloadingActive(false);
  }, 3000);
}
 */
